module.exports = __webpack_public_path__ + "static/media/icons_Bilan pour étudiants.949b46fd.svg";